<template>
  <section class="history-charts" v-if="data && data.values">
    <div class="section">
      <h5 class="section-title">{{ $t('historystats.registos') }}</h5>

      <div class="chart-wrapper">
        <va-chart
          type="vertical-bar"
          :data="kioskData"
          :options="barsOptions">
        </va-chart>
      </div>

    </div>

    <div class="section">
      <h5 class="section-title">{{ $t('historystats.status') }}</h5>

      <div class="chart-wrapper">
        <va-chart
          type="vertical-bar"
          :data="statusData"
          :options="barsOptions">
        </va-chart>
      </div>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    viewOption: {
      type: String,
      required: false,
      default: 'day'
    }
  },
  data () {
    return {
      barsOptions: {
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: 0.9,
            categoryPercentage: 0.8,
            // display: true,
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true
            },
          }],
          yAxes: [{
            stacked: true,
            // display: true,
            ticks: {
              beginAtZero: true,
              callback: function (value) { if (value % 1 === 0) { return value } }// show only integer values
            },
            gridLines: {
              display: true
            }
          }]
        }
      },
      labels: [],
      dataAppointmentENT: [],
      dataAppointmentMissed: [],
      dataAppointmentNotApplicable: [],
      dataAppointmentNoSale: [],
      dataAppointmentPossibleSale: [],
      dataCancelled: [],
      dataCancelledHt: [],
      dataCancelledHtLoss: [],
      dataCancelledHtNoLoss: [],
      dataContactsNoSuccess: [],
      dataContactsNoSuccessHL: [],
      dataContactsPostponed: [],
      dataContactsSuccess: [],
      dataContactsSuccessHL: [],
      dataConvertedToAppointment: [],
      dataCounter: [],
      dataApp: [],
      dataWeb: [],
      dataKiosk: [],
      dataKioskHt: [],
      dataKioskHtLoss: [],
      dataKioskHtNoLoss: [],
      dataQualified: [],
      dataTrial: [],
      dataSale: [],
      dataSessions: []
    }
  },
  computed: {
    kioskData: function () {
      let data = {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('historystats.sessions'),
            backgroundColor: '#166a5b',
            data: this.dataSessions,
            stack: 1
          },
          {
            label: this.$t('historystats.kiosk'),
            backgroundColor: '#1c8976',
            data: this.dataKiosk,
            stack: 2
          },
          {
            label: this.$t('historystats.counter'),
            backgroundColor: '#29c4a9',
            data: this.dataCounter,
            stack: 2
          },
          {
            label: this.$t('historystats.app'),
            backgroundColor: '#69d5c2',
            data: this.dataApp,
            stack: 2
          },
          {
            label: this.$t('historystats.web'),
            backgroundColor: '#a9e7dc',
            data: this.dataWeb,
            stack: 2
          },
          {
            label: this.$t('historystats.cancelled_ht'),
            backgroundColor: '#666666',
            data: this.dataCancelledHt,
            stack: 2
          },
          {
            label: this.$t('historystats.kiosk_ht_loss'),
            backgroundColor: '#69d5c2',
            data: this.dataKioskHtLoss,
            stack: 3
          },
          {
            label: this.$t('historystats.kiosk_ht_no_loss'),
            backgroundColor: '#7f7f7f',
            data: this.dataKioskHtNoLoss,
            stack: 3
          },
          {
            label: this.$t('historystats.cancelled_ht_loss'),
            backgroundColor: '#b2b2b2',
            data: this.dataCancelledHtLoss,
            stack: 3
          },
          {
            label: this.$t('historystats.cancelled_ht_no_loss'),
            backgroundColor: '#d2d2d2',
            data: this.dataCancelledHtNoLoss,
            stack: 3
          },
          {
            label: this.$t('historystats.qualified'),
            backgroundColor: '#a9e7dc',
            data: this.dataQualified,
            stack: 4
          }
        ]
      }
      return data
    },
    statusData: function () {
      let data = {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('historystats.contacts_success'),
            backgroundColor: '#166a5b',
            data: this.dataContactsSuccess,
            stack: 1
          },
          {
            label: this.$t('historystats.contacts_postponed'),
            backgroundColor: '#1c8976',
            data: this.dataContactsPostponed,
            stack: 1
          },
          {
            label: this.$t('historystats.contacts_no_success'),
            backgroundColor: '#666666',
            // borderColor: this.$store.getters.palette.transparent,
            data: this.dataContactsNoSuccess,
            stack: 1
          },
          {
            label: this.$t('historystats.converted_to_appointment'),
            backgroundColor: '#29c4a9',
            data: this.dataConvertedToAppointment,
            stack: 2
          },
          {
            label: this.$t('historystats.appointment_missed'),
            backgroundColor: '#7f7f7f',
            data: this.dataAppointmentMissed,
            stack: 2
          },
          {
            label: this.$t('historystats.sale'),
            backgroundColor: '#1c8976',
            borderColor: this.$store.getters.palette.transparent,
            data: this.dataSale,
            stack: 3
          },
          {
            label: this.$t('historystats.trial'),
            backgroundColor: '#29c4a9',
            borderColor: this.$store.getters.palette.transparent,
            data: this.dataTrial,
            stack: 3
          },
          {
            label: this.$t('historystats.appointment_possible_sale'),
            backgroundColor: '#69d5c2',
            data: this.dataAppointmentPossibleSale,
            stack: 3
          },
          {
            label: this.$t('historystats.appointment_ent'),
            backgroundColor: '#a9e7dc',
            data: this.dataAppointmentENT,
            stack: 3
          },
          {
            label: this.$t('historystats.appointment_no_sale'),
            backgroundColor: '#b2b2b2',
            data: this.dataAppointmentNoSale,
            stack: 3
          },
          {
            label: this.$t('historystats.appointment_not_applicable'),
            backgroundColor: '#d2d2d2',
            data: this.dataAppointmentNotApplicable,
            stack: 3
          },
        ]
      }
      return data
    }
  },
  methods: {
    updateData: debounce(function () {
      this.labels.splice(0)
      this.dataAppointmentENT.splice(0)
      this.dataAppointmentMissed.splice(0)
      this.dataAppointmentNotApplicable.splice(0)
      this.dataAppointmentNoSale.splice(0)
      this.dataAppointmentPossibleSale.splice(0)
      this.dataCancelled.splice(0)
      this.dataCancelledHt.splice(0)
      this.dataCancelledHtLoss.splice(0)
      this.dataCancelledHtNoLoss.splice(0)
      this.dataContactsNoSuccess.splice(0)
      this.dataContactsNoSuccessHL.splice(0)
      this.dataContactsPostponed.splice(0)
      this.dataContactsSuccess.splice(0)
      this.dataContactsSuccessHL.splice(0)
      this.dataConvertedToAppointment.splice(0)
      this.dataCounter.splice(0)
      this.dataApp.splice(0)
      this.dataWeb.splice(0)
      this.dataKiosk.splice(0)
      this.dataKioskHt.splice(0)
      this.dataKioskHtLoss.splice(0)
      this.dataKioskHtNoLoss.splice(0)
      this.dataQualified.splice(0)
      this.dataTrial.splice(0)
      this.dataSale.splice(0)
      this.dataSessions.splice(0)

      if (!this.data || !this.data.values || Object.keys(this.data.values).length < 1) {
        return
      }

      let date = this.moment(this.data.from)
      let from = this.moment(this.data.from)
      let until = this.moment(this.data.until)
      let totalDays = until.diff(from, 'days')

      if (this.viewOption === 'month') {
        let currentMonth = this.moment(from).startOf('month')
        let lastMonth = this.moment(until).startOf('month')

        while (currentMonth.isSameOrBefore(lastMonth)) {
          if (currentMonth.format('YYYY-MM') === from.format('YYYY-MM') && currentMonth.format('YYYY-MM') === until.format('YYYY-MM')) {
            this.labels.push(currentMonth.format('MMMM YYYY') + ' (' + from.format('DD') + ' - ' + until.format('DD') + ')')
          } else if (currentMonth.format('YYYY-MM') === from.format('YYYY-MM')) {
            this.labels.push(currentMonth.format('MMMM YYYY') + ' (' + from.format('DD') + ' - ' + from.daysInMonth() + ')')
          } else if (currentMonth.format('YYYY-MM') === until.format('YYYY-MM')) {
            this.labels.push(currentMonth.format('MMMM YYYY') + ' (1 - ' + until.format('DD') + ')')
          } else {
            this.labels.push(currentMonth.format('MMMM YYYY'))
          }

          let dataAppointmentENT = 0
          let dataAppointmentMissed = 0
          let dataAppointmentNotApplicable = 0
          let dataAppointmentNoSale = 0
          let dataAppointmentPossibleSale = 0
          let dataCancelled = 0
          let dataCancelledHt = 0
          let dataCancelledHtLoss = 0
          let dataCancelledHtNoLoss = 0
          let dataContactsNoSuccess = 0
          let dataContactsNoSuccessHL = 0
          let dataContactsPostponed = 0
          let dataContactsSuccess = 0
          let dataContactsSuccessHL = 0
          let dataConvertedToAppointment = 0
          let dataCounter = 0
          let dataApp = 0
          let dataWeb = 0
          let dataKiosk = 0
          let dataKioskHt = 0
          let dataKioskHtLoss = 0
          let dataQualified = 0
          let dataTrial = 0
          let dataSale = 0
          let dataSessions = 0

          for (let i = 1; i <= currentMonth.daysInMonth(); i++) {
            let date = this.moment(currentMonth.format('YYYY-MM') + '-' + i, 'YYYY-MM-DD')

            if (date.format('YYYY-MM-DD') in this.data.values) {
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_ent']) dataAppointmentENT += this.data.values[date.format('YYYY-MM-DD')]['appointment_ent']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_missed']) dataAppointmentMissed += this.data.values[date.format('YYYY-MM-DD')]['appointment_missed']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable']) dataAppointmentNotApplicable += this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale']) dataAppointmentNoSale += this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale']) dataAppointmentPossibleSale += this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled']) dataCancelled += this.data.values[date.format('YYYY-MM-DD')]['cancelled']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht']) dataCancelledHt += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss']) dataCancelledHtLoss += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss']) dataCancelledHtNoLoss += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success']) dataContactsNoSuccess += this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl']) dataContactsNoSuccessHL += this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed']) dataContactsPostponed += this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_success']) dataContactsSuccess += this.data.values[date.format('YYYY-MM-DD')]['contacts_success']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl']) dataContactsSuccessHL += this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl']
              if (this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment']) dataConvertedToAppointment += this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment']
              if (this.data.values[date.format('YYYY-MM-DD')]['counter']) dataCounter += this.data.values[date.format('YYYY-MM-DD')]['counter']
              if (this.data.values[date.format('YYYY-MM-DD')]['app']) dataApp += this.data.values[date.format('YYYY-MM-DD')]['app']
              if (this.data.values[date.format('YYYY-MM-DD')]['web']) dataWeb += this.data.values[date.format('YYYY-MM-DD')]['web']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk']) dataKiosk += this.data.values[date.format('YYYY-MM-DD')]['kiosk']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']) dataKioskHt += this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']) dataKioskHtLoss += this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['qualified']) dataQualified += this.data.values[date.format('YYYY-MM-DD')]['qualified']
              if (this.data.values[date.format('YYYY-MM-DD')]['trial']) dataTrial += this.data.values[date.format('YYYY-MM-DD')]['trial']
              if (this.data.values[date.format('YYYY-MM-DD')]['sale']) dataSale += this.data.values[date.format('YYYY-MM-DD')]['sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['sessions']) dataSessions += this.data.values[date.format('YYYY-MM-DD')]['sessions']
            }
          }

          this.dataAppointmentENT.push(dataAppointmentENT)
          this.dataAppointmentMissed.push(dataAppointmentMissed)
          this.dataAppointmentNotApplicable.push(dataAppointmentNotApplicable)
          this.dataAppointmentNoSale.push(dataAppointmentNoSale)
          this.dataAppointmentPossibleSale.push(dataAppointmentPossibleSale)
          this.dataCancelled.push(dataCancelled)
          this.dataCancelledHt.push(dataCancelledHt)
          this.dataCancelledHtLoss.push(dataCancelledHtLoss)
          this.dataCancelledHtNoLoss.push(dataCancelledHtNoLoss)
          this.dataContactsNoSuccess.push(dataContactsNoSuccess)
          this.dataContactsNoSuccessHL.push(dataContactsNoSuccessHL)
          this.dataContactsPostponed.push(dataContactsPostponed)
          this.dataContactsSuccess.push(dataContactsSuccess)
          this.dataContactsSuccessHL.push(dataContactsSuccessHL)
          this.dataConvertedToAppointment.push(dataConvertedToAppointment)
          this.dataCounter.push(dataCounter)
          this.dataApp.push(dataApp)
          this.dataWeb.push(dataWeb)
          this.dataKiosk.push(dataKiosk)
          this.dataKioskHt.push(dataKioskHt)
          this.dataKioskHtLoss.push(dataKioskHtLoss)
          this.dataQualified.push(dataQualified)
          this.dataTrial.push(dataTrial)
          this.dataSale.push(dataSale)
          this.dataSessions.push(dataSessions)
          this.dataKioskHtNoLoss.push(dataKioskHt - dataKioskHtLoss)

          currentMonth.add(1, 'months')
        }
      } else if (this.viewOption === 'week') {
        let weekEnd = this.moment(from).subtract(1, 'days')
        let weekStart = weekEnd.clone()
        while (date.isSameOrBefore(until)) {
          weekStart = this.moment(weekEnd).add(1, 'days')
          until.diff(date, 'days') >= 6 ? weekEnd = this.moment(weekStart).add(6, 'days') : weekEnd = this.moment(until)

          this.labels.push(weekStart.format('DD/MM') + ' - ' + weekEnd.format('DD/MM'))

          let max = until.diff(date, 'days')
          if (max >= 7) max = 6

          let dataAppointmentENT = 0
          let dataAppointmentMissed = 0
          let dataAppointmentNotApplicable = 0
          let dataAppointmentNoSale = 0
          let dataAppointmentPossibleSale = 0
          let dataCancelled = 0
          let dataCancelledHt = 0
          let dataCancelledHtLoss = 0
          let dataCancelledHtNoLoss = 0
          let dataContactsNoSuccess = 0
          let dataContactsNoSuccessHL = 0
          let dataContactsPostponed = 0
          let dataContactsSuccess = 0
          let dataContactsSuccessHL = 0
          let dataConvertedToAppointment = 0
          let dataCounter = 0
          let dataApp = 0
          let dataWeb = 0
          let dataKiosk = 0
          let dataKioskHt = 0
          let dataKioskHtLoss = 0
          let dataQualified = 0
          let dataTrial = 0
          let dataSale = 0
          let dataSessions = 0

          for (let i = 0; i <= max; i++) {
            if (date.format('YYYY-MM-DD') in this.data.values) {
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_ent']) dataAppointmentENT += this.data.values[date.format('YYYY-MM-DD')]['appointment_ent']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_missed']) dataAppointmentMissed += this.data.values[date.format('YYYY-MM-DD')]['appointment_missed']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable']) dataAppointmentNotApplicable += this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale']) dataAppointmentNoSale += this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale']) dataAppointmentPossibleSale += this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled']) dataCancelled += this.data.values[date.format('YYYY-MM-DD')]['cancelled']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht']) dataCancelledHt += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss']) dataCancelledHtLoss += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss']) dataCancelledHtNoLoss += this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success']) dataContactsNoSuccess += this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl']) dataContactsNoSuccessHL += this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed']) dataContactsPostponed += this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_success']) dataContactsSuccess += this.data.values[date.format('YYYY-MM-DD')]['contacts_success']
              if (this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl']) dataContactsSuccessHL += this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl']
              if (this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment']) dataConvertedToAppointment += this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment']
              if (this.data.values[date.format('YYYY-MM-DD')]['counter']) dataCounter += this.data.values[date.format('YYYY-MM-DD')]['counter']
              if (this.data.values[date.format('YYYY-MM-DD')]['app']) dataApp += this.data.values[date.format('YYYY-MM-DD')]['app']
              if (this.data.values[date.format('YYYY-MM-DD')]['web']) dataWeb += this.data.values[date.format('YYYY-MM-DD')]['web']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk']) dataKiosk += this.data.values[date.format('YYYY-MM-DD')]['kiosk']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']) dataKioskHt += this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']
              if (this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']) dataKioskHtLoss += this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']
              if (this.data.values[date.format('YYYY-MM-DD')]['qualified']) dataQualified += this.data.values[date.format('YYYY-MM-DD')]['qualified']
              if (this.data.values[date.format('YYYY-MM-DD')]['trial']) dataTrial += this.data.values[date.format('YYYY-MM-DD')]['trial']
              if (this.data.values[date.format('YYYY-MM-DD')]['sale']) dataSale += this.data.values[date.format('YYYY-MM-DD')]['sale']
              if (this.data.values[date.format('YYYY-MM-DD')]['sessions']) dataSessions += this.data.values[date.format('YYYY-MM-DD')]['sessions']
            }

            date.add(1, 'days')
          }

          this.dataAppointmentENT.push(dataAppointmentENT)
          this.dataAppointmentMissed.push(dataAppointmentMissed)
          this.dataAppointmentNotApplicable.push(dataAppointmentNotApplicable)
          this.dataAppointmentNoSale.push(dataAppointmentNoSale)
          this.dataAppointmentPossibleSale.push(dataAppointmentPossibleSale)
          this.dataCancelled.push(dataCancelled)
          this.dataCancelledHt.push(dataCancelledHt)
          this.dataCancelledHtLoss.push(dataCancelledHtLoss)
          this.dataCancelledHtNoLoss.push(dataCancelledHtNoLoss)
          this.dataContactsNoSuccess.push(dataContactsNoSuccess)
          this.dataContactsNoSuccessHL.push(dataContactsNoSuccessHL)
          this.dataContactsPostponed.push(dataContactsPostponed)
          this.dataContactsSuccess.push(dataContactsSuccess)
          this.dataContactsSuccessHL.push(dataContactsSuccessHL)
          this.dataConvertedToAppointment.push(dataConvertedToAppointment)
          this.dataCounter.push(dataCounter)
          this.dataApp.push(dataApp)
          this.dataWeb.push(dataWeb)
          this.dataKiosk.push(dataKiosk)
          this.dataKioskHt.push(dataKioskHt)
          this.dataKioskHtLoss.push(dataKioskHtLoss)
          this.dataQualified.push(dataQualified)
          this.dataTrial.push(dataTrial)
          this.dataSale.push(dataSale)
          this.dataSessions.push(dataSessions)
          this.dataKioskHtNoLoss.push(dataKioskHt - dataKioskHtLoss)
        }
      } else { // day
        for (let i = 0; i <= totalDays; i++) {
          this.labels.push(date.format('DD/MM'))
          let kioskHt = 0
          let kioskHtLoss = 0
          if (date.format('YYYY-MM-DD') in this.data.values) {
            this.data.values[date.format('YYYY-MM-DD')]['appointment_ent'] ? this.dataAppointmentENT.push(this.data.values[date.format('YYYY-MM-DD')]['appointment_ent']) : this.dataAppointmentENT.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['appointment_missed'] ? this.dataAppointmentMissed.push(this.data.values[date.format('YYYY-MM-DD')]['appointment_missed']) : this.dataAppointmentMissed.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable'] ? this.dataAppointmentNotApplicable.push(this.data.values[date.format('YYYY-MM-DD')]['appointment_not_applicable']) : this.dataAppointmentNotApplicable.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale'] ? this.dataAppointmentNoSale.push(this.data.values[date.format('YYYY-MM-DD')]['appointment_no_sale']) : this.dataAppointmentNoSale.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale'] ? this.dataAppointmentPossibleSale.push(this.data.values[date.format('YYYY-MM-DD')]['appointment_possible_sale']) : this.dataAppointmentPossibleSale.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['cancelled'] ? this.dataCancelled.push(this.data.values[date.format('YYYY-MM-DD')]['cancelled']) : this.dataCancelled.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht'] ? this.dataCancelledHt.push(this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht']) : this.dataCancelledHt.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss'] ? this.dataCancelledHtLoss.push(this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_loss']) : this.dataCancelledHtLoss.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss'] ? this.dataCancelledHtNoLoss.push(this.data.values[date.format('YYYY-MM-DD')]['cancelled_ht_no_loss']) : this.dataCancelledHtNoLoss.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success'] ? this.dataContactsNoSuccess.push(this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success']) : this.dataContactsNoSuccess.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl'] ? this.dataContactsNoSuccessHL.push(this.data.values[date.format('YYYY-MM-DD')]['contacts_no_success_hl']) : this.dataContactsNoSuccessHL.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed'] ? this.dataContactsPostponed.push(this.data.values[date.format('YYYY-MM-DD')]['contacts_postponed']) : this.dataContactsPostponed.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['contacts_success'] ? this.dataContactsSuccess.push(this.data.values[date.format('YYYY-MM-DD')]['contacts_success']) : this.dataContactsSuccess.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl'] ? this.dataContactsSuccessHL.push(this.data.values[date.format('YYYY-MM-DD')]['contacts_success_hl']) : this.dataContactsSuccessHL.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment'] ? this.dataConvertedToAppointment.push(this.data.values[date.format('YYYY-MM-DD')]['converted_to_appointment']) : this.dataConvertedToAppointment.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['counter'] ? this.dataCounter.push(this.data.values[date.format('YYYY-MM-DD')]['counter']) : this.dataCounter.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['app'] ? this.dataApp.push(this.data.values[date.format('YYYY-MM-DD')]['app']) : this.dataApp.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['web'] ? this.dataWeb.push(this.data.values[date.format('YYYY-MM-DD')]['web']) : this.dataWeb.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['kiosk'] ? this.dataKiosk.push(this.data.values[date.format('YYYY-MM-DD')]['kiosk']) : this.dataKiosk.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht'] ? this.dataKioskHt.push(this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']) : this.dataKioskHt.push(0)
            kioskHt = this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht']
            this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss'] ? this.dataKioskHtLoss.push(this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']) : this.dataKioskHtLoss.push(0)
            kioskHtLoss = this.data.values[date.format('YYYY-MM-DD')]['kiosk_ht_loss']
            this.data.values[date.format('YYYY-MM-DD')]['qualified'] ? this.dataQualified.push(this.data.values[date.format('YYYY-MM-DD')]['qualified']) : this.dataQualified.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['trial'] ? this.dataTrial.push(this.data.values[date.format('YYYY-MM-DD')]['trial']) : this.dataTrial.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['sale'] ? this.dataSale.push(this.data.values[date.format('YYYY-MM-DD')]['sale']) : this.dataSale.push(0)
            this.data.values[date.format('YYYY-MM-DD')]['sessions'] ? this.dataSessions.push(this.data.values[date.format('YYYY-MM-DD')]['sessions']) : this.dataSessions.push(0)
          } else {
            this.dataAppointmentENT.push(0)
            this.dataAppointmentMissed.push(0)
            this.dataAppointmentNotApplicable.push(0)
            this.dataAppointmentNoSale.push(0)
            this.dataAppointmentPossibleSale.push(0)
            this.dataCancelled.push(0)
            this.dataCancelledHt.push(0)
            this.dataCancelledHtLoss.push(0)
            this.dataCancelledHtNoLoss.push(0)
            this.dataContactsNoSuccess.push(0)
            this.dataContactsNoSuccessHL.push(0)
            this.dataContactsPostponed.push(0)
            this.dataContactsSuccess.push(0)
            this.dataContactsSuccessHL.push(0)
            this.dataConvertedToAppointment.push(0)
            this.dataCounter.push(0)
            this.dataApp.push(0)
            this.dataWeb.push(0)
            this.dataKiosk.push(0)
            this.dataKioskHt.push(0)
            this.dataKioskHtLoss.push(0)
            this.dataQualified.push(0)
            this.dataTrial.push(0)
            this.dataSale.push(0)
            this.dataSessions.push(0)
          }
          this.dataKioskHtNoLoss.push(kioskHt - kioskHtLoss)
          date.add(1, 'days')
        }
      }
    }, 500)
  },
  watch: {
    data: {
      handler: function () {
        this.updateData()
      },
      immediate: true
    },
    viewOption: function () {
      this.updateData()
    }
  }
}
</script>

<style lang="scss">

.history-charts {

  .section {
    margin-bottom: 2rem;

    .section-title {
      margin-bottom: 1.5rem;
    }

    .chart-wrapper {
      height: 300px;
    }
  }
}
</style>
